import styles from './password-helper-list.module.css';
import clsx from 'clsx';
import { MaterialSymbolIcon } from '@/components/material-symbol-link';
import { PasswordRequirement, passwordRequirements } from '@/util/validators';
import { useTranslation } from '@/contexts/i18n-context';

interface PasswordHelperListItemProps {
  requirement: PasswordRequirement;
  password: string;
}

function PasswordHelperListItem({ requirement, password }: PasswordHelperListItemProps) {
  const isMet = requirement.regex.test(password);
  const { t } = useTranslation();

  return (
    <li className={clsx('body-3', isMet && styles.passwordRequirementSuccess)}>
      {isMet ? <MaterialSymbolIcon name="check" /> : <span>•</span>}
      {t(requirement.messageKey)}
    </li>
  );
}

interface PasswordHelperListProps {
  password: string;
}

export function PasswordHelperList({ password }: PasswordHelperListProps) {
  return (
    <ul className={styles.passwordRequirements}>
      {passwordRequirements.map((requirement) => (
        <PasswordHelperListItem
          key={requirement.messageKey}
          requirement={requirement}
          password={password}
        />
      ))}
    </ul>
  );
}
